import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Government from './pages/Government';
import Requests from './pages/Requests';
import './App.scss';
import EndUserLicenseAgreement from './pages/EndUserLicenseAgreement';
import { usePageMeta } from './seo';

const App = () => {
  usePageMeta();

  return (
    <Routes>
      <Route path="/home" element={<Home />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/government-amendment-to-terms" element={<Government />} />
      <Route path="/requests" element={<Requests />} />
      <Route path="/eula" element={<EndUserLicenseAgreement />} />
      <Route path="/" element={<Home />} />
    </Routes>
  );
}

export default App;
